import { render, staticRenderFns } from "./ClientThingsCatalogItemPage.vue?vue&type=template&id=0ad24678&scoped=true&"
import script from "./ClientThingsCatalogItemPage.vue?vue&type=script&lang=ts&"
export * from "./ClientThingsCatalogItemPage.vue?vue&type=script&lang=ts&"
import style0 from "./ClientThingsCatalogItemPage.vue?vue&type=style&index=0&id=0ad24678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad24678",
  null
  
)

export default component.exports